module.exports = __webpack_public_path__ + "assets/img/jewelryBox.db673321.png";